var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visibleOpenTableName)?_c('div',{staticClass:"open-table-banner"},[_c('div',{staticClass:"table-name"},[_c('strong',[_vm._v("Open Table:")]),_vm._v(" "+_vm._s(_vm.visibleOpenTableName)+" ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }